<h1 [innerHTML]="title" class="paragraph-headline" mat-dialog-title></h1>

@if (imageUrl) {
  <img [src]="imageUrl" class="cropped-300h-fullWidth mb-2" default="./assets/images/logos/default-image300w.png" />
}

<div mat-dialog-content>
  <p [innerHTML]="message"></p>
</div>

@if (primaryButton === "yes") {
  <div mat-dialog-actions>
    <button (click)="onConfirm()" appFocusAndSelect class="mr-2" color="primary" mat-flat-button>Yes</button>
    <button (click)="onDismiss()" mat-flat-button>No</button>
  </div>
}

@if (primaryButton === "no") {
  <div mat-dialog-actions>
    <button (click)="onDismiss()" appFocusAndSelect class="mr-2" mat-flat-button>No</button>
    <button (click)="onConfirm()" color="warn" mat-flat-button>Yes</button>
  </div>
}
